import React, { useMemo } from 'react';
import { getActiveSalesPrice, gtinToJsonLd } from '../../../helpers/productHelper';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { originSelector } from '../../../modules/selectors/vHostRequestLocation';
import { useLocation } from 'react-router-dom';
import { JsonLd } from 'react-schemaorg';
import { seoMetaDataSelector } from '../../../modules/selectors/standort/seoMetaData';
import { Helmet } from 'react-helmet';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';


function getMetaData({ article, soldOut, origin, pathname, isExact }) {
    const {
        _id,
        bezeichnung,
        ean,
        googleDescription,
        gtin,
        hersteller: brand,
        id,
        images,
        isOwnArticle,
        marketingText: description,
        shownId,
        herstellerangaben,
    } = article;

    const hersteller = herstellerangaben ? herstellerangaben.firma : brand;

    const availability = `http://schema.org/${soldOut ? 'OutOfStock' : 'InStock'}`;
    const price = getActiveSalesPrice(article).toFixed(2);

    let sku;
    if (isOwnArticle) {
        sku = shownId || _id;
    } else {
        sku = id;
    }

    let name;
    if (isOwnArticle && googleDescription) {
        name = googleDescription;
    } else {
        name = bezeichnung;
    }

    const image = _.head(images);
    const url = `${origin}${pathname}${isExact ? '' : '/exakt'}`;
    const gtinJsonLdData = gtinToJsonLd({ gtin: isOwnArticle ? ean : gtin });

    return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        sku,
        image,
        name,
        description,
        brand: {
            '@type': 'Thing',
            name: hersteller,
        },
        offers: {
            '@type': 'Offer',
            url,
            itemCondition: 'http://schema.org/NewCondition',
            availability,
            price,
            priceCurrency: 'EUR',
        },
        ...gtinJsonLdData,
    };
}

function ProductDetailMeta({ variant, soldOut, isExact }) {
    const origin = useSelector(originSelector);
    const { pathname } = useLocation();
    const seoMetaData = useSelector(seoMetaDataSelector);
    const markenStandort = useSelector(markenStandortSelector);

    const metaData = useMemo(() => {
        return getMetaData({ article: variant, soldOut, origin, pathname, isExact });
    }, [isExact, origin, pathname, soldOut, variant]);

    const titlePrefix = seoMetaData?.title || variant.seoTitle || '';
    let titlePostfix = markenStandort?.seoMetaDataTitlePostfix ? ` | ${markenStandort?.seoMetaDataTitlePostfix}` : '| Autoteile plus Service';
    if (titlePostfix === " |  " || titlePrefix.includes(" | ")) {
        titlePostfix = "";
    }

    return (
        <>
            <Helmet>
                <title>{titlePrefix} {titlePostfix}</title>
            </Helmet>
            <JsonLd item={metaData} />
        </>
    );
}

export default ProductDetailMeta;
